import {SETTINGS} from "../config/common.settings";

export class ExperienceDTO {
  _id: string;
  name: string;
  titles: any[];
  area: string;
  location: any;
  apiId: string;
  contexts: any[];
  entryType: string;
  images: any[];
  active: boolean;
  costPerAdult: number;
  costPerChild: number;
  costPerInfant: number;
  conditionType: string;
  url: string;
  defaultImage: string;
  createdAt: string;

  constructor(experienceDTO?: any) {
    experienceDTO = experienceDTO || {};
    this._id = experienceDTO._id || '';
    this.name = experienceDTO.name || '';
    this.titles = experienceDTO.titles || [];
    this.area = experienceDTO.area || '';
    this.active = experienceDTO.active;
    this.images = experienceDTO.images || [];
    this.costPerAdult = experienceDTO.costPerAdult || 0;
    this.costPerChild = experienceDTO.costPerChild || 0;
    this.costPerInfant = experienceDTO.costPerInfant || 0;
    this.conditionType = experienceDTO.conditionType || 'OPT';
    this.createdAt = experienceDTO.createdAt || '';
    this.apiId = experienceDTO.apiId || '';
    this.url = experienceDTO.url || '';
    this.defaultImage = experienceDTO.defaultImage || '';
    this.contexts = experienceDTO.contexts || [];
    this.location = experienceDTO.location || {};
    this.entryType = experienceDTO.entryType || '';
  }
}
